import apiInstance from "../api";
import endPoints from "../endpoints";

export const registerUser = (payload) => {
  return apiInstance().post(endPoints.UserRegistration.registerUser, payload);
};
export const getRoles = () => {
  return apiInstance().get(`${endPoints.UserRegistration.getRoles}`);
};

export const getPlans = () => {
  return apiInstance().get(`${endPoints.UserRegistration.getPlans}`);
};
